import cubejs from '@cubejs-client/core';
import config from '../../../../config';

export const initCubejsApi = (accessToken: string) => {
  return cubejs({
    apiUrl: `${config.api.cubeApiUrl}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
